<template>
  <v-app>
    <v-snackbar v-model="snackbar" :light="light" :color="color" centered>
      <span style="white-space: pre-wrap">{{ text }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn v-if="!iconButton" :dark="!light" text v-bind="attrs" @click="snackbar = false"> 閉じる </v-btn>
        <v-btn v-else :dark="!light" icon v-bind="attrs" @click="snackbar = false">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <confirm
      :message="confirm.text"
      :title="confirm.title || undefined"
      :hide-title="confirm.hideTitle || undefined"
      :hide-icon="confirm.hideIcon || undefined"
      :icon="confirm.icon || undefined"
      :icon-color="confirm.iconColor || undefined"
      :width="confirm.width || undefined"
      @setStep="confirm.callBack"
      ref="confirmDialog"
    >
    </confirm>

    <loading v-if="loading"></loading>

    <div v-if="isLogin">
      <Menu class="hidden-print-only" />
    </div>

    <v-main>
      <router-view :key="routerKey"></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import Menu from "@/components/Menu.vue";
import Confirm from "@/components/Confirm";
import Loading from "@/components/Loading";

export default {
  name: "app",
  data() {
    return {
      routerKey: Date.now(),
      color: "",
      light: false,
      iconButton: false,
      snackbar: false,
      loading: false,
      width: "",
      text: "",
      confirm: {
        text: "",
        title: null,
        hideTitle: false,
        hideIcon: false,
        icon: null,
        iconColor: null,
        width: null,
        callBack() {}
      }
    };
  },
  computed: {
    ...mapState(["user"]),
    isLogin() {
      return this.user.isLoggedIn;
    }
  },
  components: { Menu, Confirm, Loading },
  methods: {
    alert(options) {
      if (typeof options === "string" || typeof options === "number") {
        this.text = options;
        this.color = "red darken-2";
        this.light = false;
        this.iconButton = true;
        this.width = undefined;
        this.snackbar = true;
      } else {
        if (options.confirm) {
          this.confirm.text = options.text;
          this.confirm.title = options.title;
          this.confirm.hideTitle = options.hideTitle;
          this.confirm.hideIcon = options.hideIcon;
          this.confirm.icon = options.icon;
          this.confirm.iconColor = options.iconColor;
          this.confirm.callBack = options.callBack;
          this.$refs.confirmDialog.open();
        } else {
          this.text = options.text;
          this.color = options.color ? options.color : "red darken-2";
          this.light = options.light;
          this.iconButton = typeof options.iconButton === "undefined" ? true : options.iconButton;
          this.snackbar = true;
        }
      }
    }
  },
  mounted() {
    //alertスタイルを変更
    window.alert = (options) => this.alert(options);
    //loading
    window.openLoading = () => (this.loading = true);
    window.closeLoading = () => (this.loading = false);
    window.reloadRouter = () => (this.routerKey = Date.now());
  }
};
</script>

<style>
html {
  overflow-y: auto;
}
.v-snack:not(.v-snack--absolute) {
  height: 100%;
  position: fixed;
  z-index: 1000;
}
.v-data-table__mobile-row__header {
  min-width: 75px !important;
}

.theme--light.v-card > .v-card__text,
.theme--light.v-card > .v-card__subtitle {
  color: rgba(0, 0, 0, 1);
}
</style>
